import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';

export interface Report {
  id: string;
  linkedin_url: string;
  job_url: string;
  resume_path: string;
  status: 'pending' | 'completed' | 'failed';
  company_name_from_make: string;
  job_title_from_make: string;
  created_at: string;
  output_report_pdf_full_url?: string;
}

export function useReports() {
  const [reports, setReports] = useState<Report[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchReports = async () => {
      try {
        const { data, error } = await supabase
          .from('reports')
          .select('*')
          .order('created_at', { ascending: false });

        if (error) throw error;
        setReports(data || []);
      } catch (err) {
        console.error('Error fetching reports:', err);
        setError('Failed to load reports');
      } finally {
        setLoading(false);
      }
    };

    fetchReports();

    // Subscribe to realtime changes
    const channel = supabase
      .channel('reports_channel')
      .on('postgres_changes', 
        { 
          event: '*', 
          schema: 'public', 
          table: 'reports' 
        }, 
        () => {
          fetchReports();
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, []);

  return { reports, loading, error };
}